/* eslint-disabled */

import Risk from "@/entity/Risk";
import {helper} from "@/services/Helper";

export default class RiskExtend {


    constructor(object?: any) {
    }

    postConstruct() {
        const self: Risk = this as any
        if (helper.empty(self.uuid)) {
            self.uuid = helper.generateId()
        }
    }
}
